import { Button } from 'antd'

import { useNavigate } from '@eastcoal/router/exports/react-router'

export const BackButton = () => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      window.close()
    }
  }

  return (
    <Button type='default' onClick={handleClick}>
      返回
    </Button>
  )
}
